import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { retry, catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { BaseComponents } from '../base.component';

import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class CacheService extends BaseComponents{

  public layout$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService,
    //private logger: NGXLogger
  ) { 
    super(injectorObj);
  }

  delayLayout(ms:number = 1500) {
    let self = this;
    this.layout$.next(0)
    return new Promise(function (resolve) {
      setTimeout(() => {
        self.layout$.next(ms);
        resolve(true)
      }, ms);
    })
  }

  getStorage(key) {
    let self = this;
    const url = `${environment.endpointBackend}/api/getStorage`;
    return new Promise(function (resolve) {
      //console.log('CacheService:key', key)
      if (!key) {
        resolve({
          response_code: "40001",
          response_desc: "key not empty"
        });
        return;
      }
      self.httpClient.post(url, { key: key }).subscribe(res => {
        resolve(res);
      }, () => {
        resolve({
          response_code: "40001",
          response_desc: "Error"
        });
      })
    })
  }

  setStorage(key, value) {
    let self = this;
    const url = `${environment.endpointBackend}/api/setStorage`;
    return new Promise(function (resolve) {
      self.httpClient.post(url, { key: key, value: value }).subscribe(res => {
        resolve(res);
      }, () => {
        resolve({
          response_code: "40001",
          response_desc: "Error"
        });
      })
    })
  }

}
